import { makeStyles } from '@material-ui/core';

import Skeleton from '@mui/material/Skeleton';
import { Theme } from '@mui/material';

const useTheme = makeStyles<Theme, { height: number; width: number }>(() => ({
  container: { margin: '0px 20px' },
  title: { display: 'flex', alignItems: 'start' },
  titleIcon: {
    width: 30,
    height: 30,
    margin: '25px 0px',
    transform: 'none'
  },
  titleLabel: {
    width: 110,
    height: 30,
    margin: '25px 15px',
    transform: 'none'
  },
  content: { display: 'flex', alignItems: 'start' },
  contentSkeleton: ({ width, height }) => ({
    width,
    height,
    margin: '0px 0px 32px 45px',
    transform: 'none'
  })
}));

export const SectionSkeleton = ({ height = 100, width = 310 }) => {
  const classes = useTheme({ height, width });

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <Skeleton className={classes.titleIcon} />
        <Skeleton className={classes.titleLabel} />
      </div>
      <div className={classes.content}>
        <Skeleton className={classes.contentSkeleton} />
      </div>
    </div>
  );
};
